import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getQuizResultList} from "examsbook-react-sdk/actions/quizResultList";

/**
 * useUserOverallPerformance chart.
 * @returns {*}
 */
export default function useUserOverallPerformance() {
    const quizResultList = useSelector((state)=>state.quizResultList);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    useEffect(() => {
        if (user && user.selectedExam) {
            dispatch(getQuizResultList())
        }
    }, [user]);
    const isLoading = quizResultList.status === 'PENDING'
    const overAllPerformanceData = quizResultList && quizResultList.data? quizResultList.data.overAllPerformance : {};
    return {
        overAllPerformanceData,
        isLoading
    };
}